<template>
  <div class="allbc">
    <b-link v-b-modal.allbc> Alle Anliegen</b-link>
    <b-modal id="allbc" title="Alle Anliegen" size="xl" ok-only>
    <b-form>
      <b-form-input v-model="search" autocomplete="off"></b-form-input>
    </b-form>
    <b-list-group flush>
      <b-list-group-item v-for="bc in filteredBusinessCases" :key="bc.id">
        <b-badge variant="info" pill>{{bc.status}}</b-badge>
        {{bc.name}}

        <b-badge variant="light" pill>{{bc.category}}</b-badge>

        <b-link v-if="dialog && !isActive(bc)" @click="activate(bc)" title="activate">
          <b-icon v-if="dialog && dialog.dialogueId" variant="success" icon="circle" font-scale="1.5" class="float-right" ></b-icon>
        </b-link>
        <b-badge v-else  variant="warning" pill class="float-right">ACTIVE</b-badge>

      </b-list-group-item>
    </b-list-group>

    </b-modal>
    </div>
</template>

<script>

export default {
  name: 'AllBusinessCasesUngrouped',
  components: {
  },
  data() {
    return {
      search: ''
    }
  },
  methods: {
    activate(bc) {
      this.$store.dispatch('setBusinessCaseStatusInDialogue', { 'dialogId': this.dialog.dialogueId, 'businessCaseId': bc.id , 'status': 'ACTIVE'});
    },
    isActive(bc) {
      if( !this.dialog ) {
        return false;
      }
      for( var abc in this.dialogState.activeBusinessCases ) {

        if( this.dialogState.activeBusinessCases[abc].id == bc.id ) {
          return true;
        }
      }

      return false;
    }
  },
  computed: {
    allBusinessCasesUngrouped () {
      if( this.$store.state.businessCasesUngrouped ) {
        return this.$store.state.businessCasesUngrouped;
      } else {
        return null;
      }
    },
    filteredBusinessCases() {
      const v = this.search.toLowerCase()
      if( this.$store.state.businessCasesUngrouped ) {
        return this.$store.state.businessCasesUngrouped.filter(function(bc){
          return bc.name.toLowerCase().indexOf(v) > -1;
        })
      } else {
        return null;
      }
    },
    dialog () {
      return this.$store.state.dialog;
    },
    dialogState () {
      return this.$store.state.dialogState;
    }
  }
}
</script>

<style scoped>

</style>
